import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { buttonOptions } from './ButtonOptionsData';

import styles from './Navigation.module.css';
import { logout } from '../../api/Authentication';

const Button = ({ role, setRole }) => {
    const navigate = useNavigate();
    const { first, second } = buttonOptions[role] || buttonOptions.public;

    const isLogout = second.link === '/logout';

    async function handle_logout(e) {
        if (!isLogout) return;
        e.preventDefault();

        await logout();
        setRole('public');
        navigate('/', { replace: true });
    }

    return (
        <button type="button" className={styles.btnAuth}>
            <NavLink className={`${styles.navButton} ${styles.navLink}`} to={first.link}>
                {first.label}
            </NavLink>
            /
            <NavLink
                onClick={handle_logout}
                className={`${styles.navButton} ${styles.navLink}`}
                to={second.link}
            >
                {second.label}
            </NavLink>
        </button>
    );
};

export default Button;